import {
  ExpedientDocumentationStatus,
  ExpedientStatus,
} from '@/interfaces/expedient'

// Container status values according to API validation
export const CONTAINER_STATUS_LABELS: Record<string, string> = {
  CREATED: 'Creado',
  READY_TO_TRANSPORT: 'Listo para transportar',
  ORIGIN_RECEIVED: 'Recibido en origen',
  INTERNATIONAL_TRANSIT: 'En tránsito internacional',
  DESTINY_ARRIVED: 'Llegado a destino',
  BORDER_RELEASED: 'Liberado en frontera',
  NATIONAL_TRANSIT: 'En tránsito nacional',
  WAREHOUSE_RECEIVED: 'Recibido en almacén',
  READY_TO_EMPTY_RETURN: 'Listo para retorno vacío',
  EMPTY_RETURNED: 'Retorno vacío completado',
  CANCELLED: 'Cancelado',
}

// Map OrderReceiptStatus to Spanish labels (keeping for backward compatibility)
export const EXPEDIENT_STATUS_LABELS: Record<ExpedientStatus, string> = {
  CREATED: 'Creada',
  IN_PROCESS: 'En proceso',
  PROCESSED: 'Procesada',
  COMPLETED: 'Completada',
  CANCELLED: 'Cancelada',
  DELIVERY_ASSIGNED: 'Asignada a mensajero',
  ACCEPTED: 'Aceptada por mensajero',
  IN_TRANSIT: 'En tránsito',
  DELIVERED: 'Entregada',
  REFUNDED: 'Reembolsada',
}

// Map OrderPaymentStatus to Spanish labels
export const EXPEDIENT_DOCUMENTATION_STATUS_LABELS: Record<
  ExpedientDocumentationStatus,
  string
> = {
  PENDING: 'Pendiente',
  COMPLETED: 'Completada',
  PARTIALLY_COMPLETED: 'Parcialmente completada',
}

// Generate status options for containers
export const containerStatusOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(CONTAINER_STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Generate status options for order status (keeping for backward compatibility)
export const expedientStatusOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(EXPEDIENT_STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Generate status options for payment status
export const expedientDocumentationStatusOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(EXPEDIENT_DOCUMENTATION_STATUS_LABELS).map(
    ([value, label]) => ({
      value,
      label,
    })
  ),
]

// Type for status option
export interface StatusOption {
  value: string
  label: string
}
